var _excluded = ["outlineColor", "icon", "title", "text", "isActive", "onClick"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef, useContext } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import { KeyboardEventKeys } from "../../../typings/types";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import TextAtm from "../TextAtm";
import { IconContainer, Wrapper } from "./ProductCategoryTabAtm.styled";
var ProductCategoryTabAtm = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var outlineColor = _ref.outlineColor,
    icon = _ref.icon,
    title = _ref.title,
    text = _ref.text,
    isActive = _ref.isActive,
    onClick = _ref.onClick,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var handleOnKeyDown = function handleOnKeyDown(event) {
    if (event.key === KeyboardEventKeys.ENTER || event.key === KeyboardEventKeys.SPACE) {
      onClick(event);
    }
  };
  return /*#__PURE__*/React.createElement(Wrapper, _extends({}, restProps, {
    $isActive: isActive,
    $outlineColor: outlineColor,
    $hasText: !!text,
    $onColor: onColor,
    onClick: onClick,
    ref: ref,
    tabIndex: 0,
    onKeyDown: handleOnKeyDown
  }), icon ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(IconContainer, null, icon)) : null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextAtm, {
    pushSpace: 0,
    typography: {
      small: "small2",
      medium: "big2",
      large: "big2"
    }
  }, title), text ? /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, /*#__PURE__*/React.createElement(TextAtm, {
    pushSpace: 0,
    typography: "tiny1"
  }, text)) : null));
});
export default ProductCategoryTabAtm;